import { Address } from '../../domain/Address'
import { Voucher } from '../../domain/Voucher'

export class LandingPage {
    constructor(
        public address: Address,
        public bookingPath: string,
        public displayName: string,
        public emailAddress: string | null,
        public phoneNumber: string | null,
        public timeZone: string,
        public inService: boolean,
        public voucher: Voucher | null,
        public metaPixelId: string | null = null
    ) { }
}
